import { render, staticRenderFns } from "./building.vue?vue&type=template&id=caa2313a&scoped=true"
import script from "./building.vue?vue&type=script&lang=js"
export * from "./building.vue?vue&type=script&lang=js"
import style0 from "./building.vue?vue&type=style&index=0&id=caa2313a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa2313a",
  null
  
)

export default component.exports